import { useState } from 'react';

const useFormLogic = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [passwordType, setPasswordType] = useState<'text' | 'password'>('password');
  const [loginError, setLoginError] = useState<string>('');
  const [passwordError, setPasswordError] = useState<string>('');

  const isValidLogin = (login: string) => {
    return login.length > 0;
  };

  const isValidPass = (password: string) => {
    return password.length > 0;
  };

  const validateForm = () => {
    let isValid = true;
    if (!isValidPass(password)) {
      setPasswordError('Пожалуйста, заполните поле.');
      isValid = false;
    } else {
      setPasswordError('');
      isValid = true;
    }
    if (!isValidLogin(login)) {
      setLoginError('Пожалуйста, заполните поле.');
      isValid = false;
    } else {
      setLoginError('');
      if (isValidPass(password)) isValid = true;
    }
    return isValid;
  };

  const openRegistration = (callback: () => void) => {
    if (typeof window !== 'undefined') {
      const y = window.screen.height / 2 - 250;
      const x = window.screen.width / 2 - 250;

      const newWin = window.open(
        `/signin/main/student/new?np=true&clean=true`,
        'registration',
        `left=${x},top=${y},width=500,height=500,menubar=no,toolbar=no`,
      );
      if (newWin)
        newWin.onload = () => {
          const checkPageAuth = setInterval(() => {
            if (newWin.location.pathname === '/profile/students') {
              newWin.close();
              callback();
              clearInterval(checkPageAuth);
            }

            if (!newWin.name) {
              clearInterval(checkPageAuth);
            }
          }, 1000);
        };
    }
  };

  const openOtp = (callback: () => void) => {
    if (typeof window !== 'undefined') {
      const y = window.screen.height / 2 - 250;
      const x = window.screen.width / 2 - 250;

      const newWin = window.open(
        `/forget_password`,
        'otp',
        `left=${x},top=${y},width=500,height=500,menubar=no,toolbar=no`,
      );
      if (newWin)
        newWin.onload = () => {
          const checkPageAuth = setInterval(() => {
            if (newWin.location.pathname === '/profile/students') {
              newWin.close();
              callback();
              clearInterval(checkPageAuth);
            }

            if (!newWin.name) {
              clearInterval(checkPageAuth);
            }
          }, 1000);
        };
    }
  };

  return {
    login,
    setLogin,
    password,
    setPassword,
    passwordType,
    setPasswordType,
    loginError,
    setLoginError,
    passwordError,
    setPasswordError,
    validateForm,
    openRegistration,
    openOtp,
  };
};

export default useFormLogic;
